import React, { useRef, useState } from "react";
import { Stack, TextField, MenuItem, Button } from "@mui/material";
import ImagePickerDialog from "../ImagePickerDialog"; // шлях підстав свій
import { insertAtCursor } from "../helpers/insertAtCursor"; // шлях підстав свій

const QuestionFormOnlyText = ({ value, onChange }) => {
    const v = value || {};

    const [pickerOpen, setPickerOpen] = useState(false);
    const textInputRef = useRef(null);

    const onPickImage = (img) => {
        // img.url приходить з ImagePickerDialog
        const caption = img.originalFilename || "Зображення";

        const block =
            `\n<figure>` +
            `\n  <img src="${img.url}" alt="${caption}" style="width:50%;" />` +
            `\n  <figcaption class="imgcaption">${caption}</figcaption>` +
            `\n</figure>\n`;

        const nextText = insertAtCursor(textInputRef.current, v.text || "", block);
        onChange({ ...v, text: nextText });
        setPickerOpen(false);
    };

    return (
        <Stack spacing={2}>
            <TextField label="type" value={"text"} fullWidth select disabled>
                <MenuItem value="text">text</MenuItem>
            </TextField>

            <TextField
                label="subtitle"
                value={v.subtitle || ""}
                onChange={(e) => onChange({ ...v, subtitle: e.target.value })}
                fullWidth
            />

            <Stack direction="row" spacing={1}>
                <Button variant="outlined" onClick={() => setPickerOpen(true)}>
                    Вставити зображення
                </Button>
            </Stack>

            <TextField
                label="text (HTML)"
                value={v.text || ""}
                onChange={(e) => onChange({ ...v, text: e.target.value })}
                fullWidth
                multiline
                minRows={10}
                inputRef={textInputRef}   // ✅ важливо
            />

            <ImagePickerDialog
                open={pickerOpen}
                onClose={() => setPickerOpen(false)}
                onPick={onPickImage}
            />
        </Stack>
    );
};

export default QuestionFormOnlyText;